import React, { useEffect, useState, useRef } from "react";
import Layout from "../../../components/admin/Layout";
import Helmet from "react-helmet";
import Table from "../../../components/ui/Table";
import Pagination from "../../../components/ui/Pagination";
import InputField from "../../../components/ui/form/InputField";
import usePaginate from "../../../hooks/api/usePaginate";
import apiRequest from "../../../utils/admin/apiRequest";
import { Link } from "react-router-dom";
import { PRODUCT_BY_EXCEL } from "../../../routes/admin/adminRoutes";
import useModal from "../../../hooks/ui/useModal";
import { FaCheck, FaCircle, FaDownload, FaEye, FaPlus, FaTrashAlt } from "react-icons/fa";
import Modal from "../../../components/ui/utils/Modal";
import DeleteExcel from "../../../components/admin/import/DeleteExcel";
import Button from "../../../components/ui/utils/Button";
import ProductImport from "../../../components/admin/vendor/import/ProductImport";
import AsyncSearchSelect from "../../../components/ui/form/AsyncSearchSelect";
import ExcelAssign from "../../../components/admin/vendor/import/ExcelAssign";
import useFetch from "../../../hooks/api/useFetch";
import SelectField from "../../../components/ui/form/SelectField";
import axios from "axios";
import toast from "react-hot-toast";

const MenuPricing = () => {
  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState({});
  const [vendorManagerId, setVendorManagerId] = useState("");

  const debounceRef = useRef(null);

  const {
    data: imports,
    setFilters: setImportFilters,
    setPage,
    limit,
    currentPage,
    fetchData,
    error,
    loading,
    totalPages,
    totalItems,
  } = usePaginate({
    apiMethod: apiRequest.getExcelImportList,
    dataKey: "imports",
  });

  const { isOpen, openModal, closeModal, actionType } = useModal();

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(() => {
      setFilters((prev) => {
        const newFilters = { ...prev };

        if (search.trim()) {
          newFilters.excelName = { $regex: search.trim(), $options: "i" };
        } else {
          delete newFilters.excelName;
        }

        if (vendorManagerId) {
          newFilters.vendorManagerId = vendorManagerId;
        } else {
          delete newFilters.vendorManagerId;
        }

        console.log(newFilters);

        setImportFilters(newFilters);
        return newFilters;
      });
    }, 300);

    return () => clearTimeout(debounceRef.current);
  }, [search, vendorManagerId, setImportFilters]);


  const handleVendorChange = (e) => {

    setVendorManagerId(e.target.value);
  };


  const {
    data: vendors,
  } = useFetch({
    apiMethod: apiRequest.getVendorManager,
    body: { paginate: false, sortField: "corporateName", sortOrder: "asc" },
    autoFetch: true,
  });


 
const downloadExcel = (excelImportId) => {
  toast((t) => (
    <div className="flex flex-col gap-3">
      <p className="font-medium">Download this Excel file?</p>

      <div className="flex gap-2 justify-end">
        <button
          className="px-3 py-1 bg-gray-200 rounded"
          onClick={() => toast.dismiss(t.id)}
        >
          Cancel
        </button>

        <button
          className="px-3 py-1 bg-indigo-600 text-white rounded"
          onClick={async () => {
            toast.dismiss(t.id);

            const toastId = toast.loading("Downloading Excel...");

            try {
              const res = await axios.get(
                `${process.env.REACT_APP_BASE_URL}api/admin/v1/excel/download-products/${excelImportId}`,
                { responseType: "blob" }
              );

              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute(
                "download",
                `products_${excelImportId}.xlsx`
              );
              document.body.appendChild(link);
              link.click();
              link.remove();

              toast.success("Excel downloaded successfully", {
                id: toastId,
              });
            } catch (err) {
              console.error(err);
              toast.error("Failed to download Excel", { id: toastId });
            }
          }}
        >
          Download
        </button>
      </div>
    </div>
  ));
};



  return (
    <Layout>
      <Helmet>
        <title>Excel Imports</title>
      </Helmet>

      <div className="p-4 bg-white rounded">
        <Button onClick={() => openModal({ type: "add" })} variant="primary" isLoading={false}>
          <div className="flex items-center justify-center gap-3">
            <FaPlus />
            <p>Import Product Category</p>
          </div>
        </Button>

        <div className="grid my-2 grid-cols-1 sm:grid-cols-3 gap-2 mb-3">
          <InputField
            placeholder="Search by excel name..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <SelectField
            name="vendorManagerId"
            value={vendorManagerId}
            onChange={handleVendorChange}
            options={vendors?.vendors?.map((v) => ({
              value: v._id,
              label: v.name,
            }))}
          />

          <button
            className="py-1 text-white rounded bg-emerald-600 hover:bg-emerald-800"
            onClick={() => {
              setSearch("");
              setVendorManagerId("");
              setImportFilters({});
            }}
          >
            Clear
          </button>
        </div>

        <Table
          headers={[
            { label: "Excel Name", key: "excelName" },
            { label: "Vendor Manager", key: "vendormanager" },
            { label: "Product Count", key: "productCount" },
            { label: "Inserted", key: "inserted" },
            { label: "Updated", key: "updated" },
            { label: "Created", key: "createdAt" },
            { label: "Action" },
          ]}
          loading={loading}
          cols={5}
          error={error}
          renderRow={
            <tbody className="bg-white divide-y divide-gray-200">
              {(imports || []).map((imp) => (
                <tr key={imp._id} className="hover:bg-gray-50">
                  <td className="px-3 py-3">{imp.excelName}</td>
                  <td className="px-3 py-3 capitalize">{imp?.vendorManagerName}</td>
                  <td className="px-3 py-3">{imp.productCount}</td>
                  <td className="px-3 py-3">{imp.inserted}</td>
                  <td className="px-3 py-3">{imp.updated}</td>
                  <td className="px-3 py-3">{new Date(imp.createdAt).toLocaleDateString()}</td>
                  <td className="px-3 flex gap-2 items-center py-3">

                    <button
                      onClick={() => openModal({ type: "assign", data: { state: imp } })}
                      className="text-green-500"
                      title="assign"
                    >
                      <FaCheck size={18} />
                    </button>

                     <button
                      onClick={() => downloadExcel(imp._id)}
                      className="text-indigo-500"
                      title="Download Excel"
                    >
                      <FaDownload size={18} />
                    </button>


                    <Link to={PRODUCT_BY_EXCEL(imp._id)} className="px-3 py-1 text-blue-500 rounded">
                      <FaEye size={18} />
                    </Link>

                    <button
                      onClick={() => openModal({ type: "delete", data: { state: imp } })}
                      className="text-red-500"
                      title="Delete"
                    >
                      <FaTrashAlt size={18} />
                    </button>

                     
                  </td>
                </tr>
              ))}
            </tbody>
          }
        />

        {totalPages > 1 && (
          <Pagination
            pagination={{ currentPage, totalPages, totalItems, perPage: limit }}
            handlePageChange={setPage}
            loading={loading}
          />
        )}

        <Modal isOpen={isOpen} onClose={closeModal} size="lg" overflow={""}>
          {actionType?.type === "assign" && (
            <ExcelAssign data={actionType?.data?.state} closeModal={closeModal} callback={fetchData} />
          )}
          {actionType?.type === "add" && (
            <ProductImport data={actionType?.data?.state} closeModal={closeModal} callback={fetchData} />
          )}
          {actionType?.type === "delete" && (
            <DeleteExcel data={actionType?.data?.state} closeModal={closeModal} callback={fetchData} />
          )}

        </Modal>
      </div>
    </Layout>
  );
};

export default MenuPricing;
